import { useMutation } from "react-query";
import { uploadAudio } from "api/services/student-progress";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";

export const useUploadAudio = () => {
  return useMutation<string, TApiError, Blob>(
    (audioBlob: Blob) => uploadAudio(audioBlob),
    {
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
